import { FC } from 'react';
import { IconButton, Tooltip, Button, Stack } from '@mui/material';
import { Download, Refresh, PersonAdd } from '@mui/icons-material';
import { useUsers } from '../contexts/users.context';
import { useTranslation } from 'src/hooks/useTranslationHook';

interface UsersHeaderProps {
  onExport: (format: 'pdf' | 'excel') => Promise<void>;
  onAddUser?: () => void;
}

const UsersHeader: FC<UsersHeaderProps> = ({ onExport, onAddUser }) => {
  const { translateText } = useTranslation();
  const { state } = useUsers();

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleExport = async () => {
    await onExport('excel');
  };

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 1, sm: 2 }}
      data-testid="users-header"
      sx={{
        flex: 1,
        justifyContent: { xs: 'stretch', sm: 'flex-end' },
        alignItems: { xs: 'stretch', sm: 'center' },
        width: { xs: '100%', sm: 'auto' },
      }}
    >
      <Tooltip title={translateText('users.header.refreshData')}>
        <IconButton
          color="primary"
          onClick={handleRefresh}
          disabled={state.isLoading}
          sx={{
            minHeight: { xs: '44px', sm: 'auto' },
            minWidth: { xs: '44px', sm: 'auto' },
          }}
          data-testid="refresh-users-button"
        >
          <Refresh />
        </IconButton>
      </Tooltip>

      <Tooltip title={translateText('users.header.exportData')}>
        <Button
          variant="outlined"
          startIcon={<Download />}
          onClick={handleExport}
          disabled={state.isLoading}
          size="small"
          sx={{
            minHeight: { xs: '44px', sm: 'auto' },
            width: { xs: '100%', sm: 'auto' },
          }}
          data-testid="export-users-button"
        >
          {translateText('users.header.export')}
        </Button>
      </Tooltip>

      {state.activeTabIndex !== 4 ? (<Tooltip title={translateText('users.header.addNewUser')}>
        <Button
          variant="contained"
          startIcon={<PersonAdd />}
          onClick={onAddUser}
          disabled={state.isLoading}
          size="small"
          sx={{
            minHeight: { xs: '44px', sm: 'auto' },
            width: { xs: '100%', sm: 'auto' },
          }}
          data-testid="add-user-button"
        >
          {translateText('users.header.addUser')}
        </Button>
      </Tooltip>) : null}
    </Stack>
  );
};

export default UsersHeader;
